@if (customTransformForm) {
  <div class="form-container" [formGroup]="customTransformForm">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Name </label>
          </div>
          <clickatell-form-validation [controlName]="'name'"
          [form]="customTransformForm"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="customTransformForm" id="name"
            [formControlName]="'name'" placeholder="Enter name"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <clickatell-form-validation [controlName]="'description'"
            [form]="customTransformForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="customTransformForm" id="description"
              [formControlName]="'description'" placeholder="Enter description"/>
            </div>
            @if (allFunctions | async; as allFunc) {
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Function </label>
                </div>
                <clickatell-form-validation [controlName]="'functionId'"
                [form]="customTransformForm"></clickatell-form-validation>
                <mat-select [formControlName]="'functionId'" class="control-dropdown"
                  (selectionChange)="selectedFunction($event.value)" placeholder="Select a function"
                            hideSingleSelectionIndicator>
                  @for (func of allFunc; track func) {
                    <mat-option
                      [value]="func.id">
                      {{ func.name }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            } @else {
              <loading-icon></loading-icon>
            }
            @if (customTransformForm?.controls['functionId']?.value && customTransformForm?.controls['params']?.value) {
              <div>
                @if (customTransformForm?.controls['params'].controls | keyvalue; as paramControls) {
                  @if (!!paramControls.length) {
                    <div class="qr-template-container">
                      <div class="qr-section title">
                        Parameters
                      </div>
                      <div class="content">
                        <ng-container >
                          @for (param of paramControls; track param) {
                            <div class="qr-section add-param"
                              [formGroup]="customTransformForm?.controls['params']">
                              <div>
                                <label class="control-label"> {{ param.key }} </label>
                              </div>
                              <ng-container
                                *ngTemplateOutlet="validators; context: { myControlName: param.key, myForm: customTransformForm?.controls['params']}">
                              </ng-container>
                              <input class="control-input" activeForm [activeForm]="customTransformForm"
                                [id]="param.key"
                                [formControlName]="param.key" placeholder="Enter value"/>
                              </div>
                            }
                          </ng-container>
                        </div>
                      </div>
                    } @else {
                      <div class="qr-template-container">
                        <div class="qr-section title">
                          No Parameters
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            </ng-container>
          </clickatell-expansion-panel>
          <clickatell-expansion-panel>
            <ng-container header>
              <mat-panel-title>
                Logic
              </mat-panel-title>
            </ng-container>
            <ng-container body>
              <div class="control-result">
                <div class="control-result-header">
                  Yes
                </div>
                <div class="control-result-container">
                  <div class="control-div">
                    <label class="control-label">
                      <span class="pont-to">Point To</span>
                      <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                    </label>
                    @if (nodeFlowDetails) {
                      <next-selector [canEditFlows]="canEdit.canEditFlows"
                        [selectorType]="'both'"
                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                        [flows]="nodeFlowDetails.flows"
                        [name]="'success'"
                        [form]="customTransformForm"
                        [stepId]="nodeFlowDetails.stepId">
                      </next-selector>
                    }
                  </div>
                </div>
              </div>
              <div class="control-result">
                <div class="control-result-header">
                  No
                </div>
                <div class="control-result-container">
                  <div class="control-div">
                    <label class="control-label">
                      <span class="pont-to">Point To</span>
                      <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                    </label>
                    @if (nodeFlowDetails) {
                      <next-selector [canEditFlows]="canEdit.canEditFlows"
                        [selectorType]="'both'"
                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                        [flows]="nodeFlowDetails.flows"
                        [name]="'error'"
                        [form]="customTransformForm"
                        [stepId]="nodeFlowDetails.stepId">
                      </next-selector>
                    }
                  </div>
                </div>
              </div>
            </ng-container>
          </clickatell-expansion-panel>
        </div>
      }


      <ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
        @if (myForm.controls[myControlName]; as control) {
          @if (control.invalid && (control.dirty || control.touched)) {
            <div style="margin-left: 0;" class="validationField"
              >
              @for (error of control.errors | keyvalue; track error) {
                <div>
                  <span class="fa fa-exclamation-circle"></span>
                  <span [id]="'validationField-' + myControlName">
                    {{ error.value }}
                  </span>
                </div>
              }
            </div>
          }
        }
      </ng-template>

